import 'isomorphic-fetch';
class ApiError {
    message;
    details;
    constructor(message) {
        this.message = message;
    }
}
class Api {
    baseUrl = 'https://domains.sportnet.online/api/v1';
    token = '';
    serializeQueryParams(parameters) {
        return Object.keys(parameters)
            .reduce((acc, p) => {
            const param = parameters[p];
            if (typeof param === 'undefined' || param === '') {
                return acc;
            }
            return [
                ...acc,
                `${encodeURIComponent(p)}=${encodeURIComponent(String(parameters[p]))}`,
            ];
        }, [])
            .join('&');
    }
    transformParameter(value, transformOperation) {
        switch (transformOperation) {
            case 'joinUsingPipes':
                return Array.isArray(value) ? value.join('|') : value;
            default:
                return value;
        }
    }
    setBaseUrl(baseUrl) {
        this.baseUrl = baseUrl;
    }
    setToken(token) {
        this.token = token;
    }
    appendAuthHeaders(headerParams) {
        const headers = new Headers(headerParams);
        if (this.token) {
            headers.append('Authorization', `Bearer ${this.token}`);
        }
        return headers;
    }
    async request(method, url, body, headers = new Headers(), queryParameters = {}) {
        const queryParams = queryParameters && Object.keys(queryParameters).length
            ? this.serializeQueryParams(queryParameters)
            : null;
        const urlWithParams = url + (queryParams ? '?' + queryParams : '');
        if (headers.get('Content-Type') === 'multipart/form-data') {
            const form = new FormData();
            for (let k in body) {
                form.append(k, body[k]);
            }
            body = form;
        }
        else if (headers.get('Content-Type') === 'application/json' &&
            body &&
            Object.keys(body).length > 0) {
            body = JSON.stringify(body);
        }
        else {
            body = undefined;
        }
        if (headers.get('Content-Type') === 'multipart/form-data') {
            headers.delete('Content-Type');
        }
        const response = await fetch(urlWithParams, { method, headers, body });
        if (response.ok) {
            return response.json();
        }
        else {
            const err = new ApiError(response.statusText);
            err.details = await response.json();
            throw err;
        }
    }
    appListDomains(appId, appSpace, parameters = {}) {
        let path = '/app/{appId}/{appSpace}/domains';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appId}', appId.toString());
        path = path.replace('{appSpace}', appSpace.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    appCreateDomain(appId, appSpace, parameters, body) {
        let path = '/app/{appId}/{appSpace}/domains';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appId}', appId.toString());
        path = path.replace('{appSpace}', appSpace.toString());
        return this.request('POST', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    appGetDomain(appId, appSpace, domain, parameters = {}) {
        let path = '/app/{appId}/{appSpace}/domains/{domain}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appId}', appId.toString());
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{domain}', domain.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    appUpdateDomain(appId, appSpace, domain, parameters, body) {
        let path = '/app/{appId}/{appSpace}/domains/{domain}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appId}', appId.toString());
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{domain}', domain.toString());
        return this.request('PUT', `${this.baseUrl}${path}`, body, headers, queryParameters);
    }
    appDeleteDomain(appId, appSpace, domain, parameters = {}) {
        let path = '/app/{appId}/{appSpace}/domains/{domain}';
        let headers = new Headers();
        let queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appId}', appId.toString());
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{domain}', domain.toString());
        return this.request('DELETE', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    getDomainInfo(domain, parameters = {}) {
        let path = '/domain/{domain}';
        let headers = new Headers();
        let queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{domain}', domain.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
    dnscheckDomain(domain, parameters = {}) {
        let path = '/dnscheck/{domain}';
        let headers = new Headers();
        let queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{domain}', domain.toString());
        return this.request('GET', `${this.baseUrl}${path}`, {}, headers, queryParameters);
    }
}
export default new Api();
